import React from 'react'
import { useStore1Selector } from 'index';
import { loginUser } from '../../../Redux/Slices/userSlice';
import usePost from '../../../hooks/usePost';
import { GracePeriodMsg } from '../../../constant/NotifyMessage';
import { Spinner } from 'reactstrap';

function UpdateGracePeriod({ loanId, onClose, reFetch }) {
    const userDet = useStore1Selector(loginUser);
    const token = userDet?.token;
    const { execute, data, pending } = usePost()

    const changeStatusFunc = () => {
        const Method = 'PATCH', endPoint = `loans/applyLoan/${loanId}`;
        const raw = JSON.stringify({
            "status": "grace-period",

        });
        execute(endPoint, raw, Method, GracePeriodMsg, token)
    }

    if (data?.status === 'success') {
        onClose();
        setTimeout(() => {
            reFetch()
        }, 2000)
    }

    return (
        <button className='btn text-white w-100' onClick={changeStatusFunc}>
            {pending ? <span>  <Spinner as="span" animation="border" size="sm" /> Loading...</span> : "Move to grace period"} </button>
    )
}

export default UpdateGracePeriod